import { createContext, useContext } from 'react';
export var StoreContext = createContext(undefined);
export var APIContext = createContext({});
export var useAPIContext = function () { return useContext(APIContext); };
export var useStoreContext = function () {
    var storeValue = useContext(StoreContext);
    if (!storeValue) {
        throw new Error('could not find js-integration-api context value; ' +
            'please ensure the component is wrapped in a <IntegrationApiProvider>');
    }
    return storeValue;
};
